import React from 'react';
import { TooltipProps } from 'recharts';
import styled from 'styled-components';

interface DataPayload {
  date: string;
  close: string;
  price: number;
  percentage: number;
}

const TooltipContainer = styled.div`
  display: flex;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 15.28px;
  font-weight: 400;
  line-height: 17.91px;
  text-align: left;
  background-color: #eaeaea;
  padding: 11.5px 15px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const formatDate = (dateString: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  };
  return new Date(dateString).toLocaleDateString('en-GB', options);
};

const CustomTooltip = ({ active, payload }: TooltipProps<string, string>) => {
  if (active && payload && payload.length) {
    const data: DataPayload = payload[0].payload;
    const formattedDate = formatDate(data.date);

    return (
      <TooltipContainer className="custom-tooltip">
        <span>₹{data.close}</span> |<span>{formattedDate}</span>
      </TooltipContainer>
    );
  }
  return null;
};

export default CustomTooltip;
